export const getSecondsToDate = (endDate?: string) => {
    const minTime = 0; // 1 second
    const maxTime = 60 * 60 - 1; // 1 hour
    const now = new Date();
    const date = endDate ? new Date(endDate).getTime() : now.setMinutes(now.getMinutes() + 1);
    const calculatedSeconds = Math.ceil((date - Date.now()) / 1000);
    return Math.max(minTime, Math.min(calculatedSeconds, maxTime));
};
